/**
 * @description This method get locale from browser setting
 */
export default function getBrowserLocale(options = {}) {
  const defaultOptions = { codeOnly: false };
  const opt = { ...defaultOptions, ...options };

  const navigatorLocale =
    navigator.languages !== undefined ? navigator.languages[0] : navigator.language;
  if (!navigatorLocale) {
    return undefined;
  }

  return opt.codeOnly ? navigatorLocale.trim().split(/-|_/)[0] : navigatorLocale.trim();
}
